import { Injectable, Injector } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { BaseApiService } from './baseapi.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  error$ = new BehaviorSubject<string | null>(null);
  hideError$ = new BehaviorSubject<boolean>(false);

  constructor() {
  }

  getError(): Observable<string | null> {
    return this.error$.asObservable();
  }

  setError(errorMessage: string) {
    this.error$.next(errorMessage);
  }

  get hideError(): Observable<boolean> {
    return this.hideError$.asObservable();
  }

  setHideError(value: boolean) {
    this.hideError$.next(value);
  }

  resetError() {
    this.error$.next(null);
  }


}
